import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';

class AboutUs extends Component {

  render() {
    return (
      <div className="content-max-width cms">
        <div className="content-max-width">
          <a href="/" className="button btn-secondary float-right" onClick={(evt) => this.props.dispatch(navigate(evt))}>Continue shopping</a>
          <h2>About Us</h2>
        </div>
        <div dangerouslySetInnerHTML={{__html: this.props.about_us}} />
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'about_us': state.store.about_us };
}

export default connect(mapStateToProps)(AboutUs);


// WEBPACK FOOTER //
// ./src/components/CmsAboutUs.jsx